import * as yup from 'yup'

export const equipment = yup.object().shape({
  companiaId: yup.string().required('La compañía es obligatorio'),
  clienteId: yup.string().required('El cliente es obligatorio'),
  siteId: yup.string().required('El site es obligatorio'),
  campamentoId: yup.string().required('El campamento es obligatorio'),
  nombre: yup.string().required('El nombre es obligatorio'),
  capacidad: yup.string().required('La capacidad es obligatorio'),
  frecuenciaMantenimiento: yup.string().required('La frecuencia es obligatorio'),
  marca: yup.string().required('La marca es obligatorio'),
  modelo: yup.string().required('El modelo es obligatorio'),
  estado: yup.string().required('El estado es obligatorio'),
})
